<template>
<Veranstaltungen v-if="componentUp == 'Veranstaltungen'"/>
<Apothekenfinder v-if="componentUp == 'Apothekenfinder'"/>
</template>

<script setup>
import Veranstaltungen from '@/components/Veranstaltungen';
import Apothekenfinder from '@/components/Apothekenfinder';
const componentUp = (typeof component === 'undefined') ? "Veranstaltungen" : component;


</script>
